import Axios from "axios";
import config from "config";
import { UPDATE_SCHEMA } from "queries";
import { headers } from "../deployments/lib";

export async function updateSchema(deployment, schema) {
    await Axios.post(
        `${config.httpProtocol}://${deployment.url}/admin`,
        {
            query: UPDATE_SCHEMA,
            variables: {
                sch: schema,
            },
        },
        {
            headers: headers(deployment),
        }
    );
}
